var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgTwitter = function SvgTwitter(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7497 3H20.8179L14.1165 10.6575L22 21.0791H15.8288L10.9917 14.7601L5.46371 21.0791H2.39113L9.55758 12.887L2 3H8.32768L12.6953 8.77575L17.7497 3ZM16.6719 19.2451H18.3711L7.402 4.73837H5.57671L16.6719 19.2451Z",
    fill: "#5C728A"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgTwitter);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE3Ljc0OTcgM0gyMC44MTc5TDE0LjExNjUgMTAuNjU3NUwyMiAyMS4wNzkxSDE1LjgyODhMMTAuOTkxNyAxNC43NjAxTDUuNDYzNzEgMjEuMDc5MUgyLjM5MTEzTDkuNTU3NTggMTIuODg3TDIgM0g4LjMyNzY4TDEyLjY5NTMgOC43NzU3NUwxNy43NDk3IDNaTTE2LjY3MTkgMTkuMjQ1MUgxOC4zNzExTDcuNDAyIDQuNzM4MzdINS41NzY3MUwxNi42NzE5IDE5LjI0NTFaIiBmaWxsPSIjNUM3MjhBIi8+Cjwvc3ZnPgo=";